export type CacheStorage = Pick<Storage, "getItem" | "setItem">;

export const browserStorage = (): CacheStorage | null => {
    try {
        return window.localStorage;
    } catch {
        return null;
    }
};

/**
 * Lists that are the same for everyone and change rarely (categories, collections, subjects) are kept in
 * storage so a visit starts with the last copy on screen while a fresh one is fetched.
 */
export const readListCache = <T>(storage: CacheStorage | null, key: string, maxAgeMs: number): T | undefined => {
    try {
        const cached = JSON.parse(storage?.getItem(key) ?? "null") as { at: number; value: T } | null;
        return cached && Date.now() - cached.at < maxAgeMs ? cached.value : undefined;
    } catch {
        return undefined;
    }
};

export const writeListCache = (storage: CacheStorage | null, key: string, value: unknown) => {
    try {
        storage?.setItem(key, JSON.stringify({ at: Date.now(), value }));
    } catch {
        // private mode or a full disk: just no cache
    }
};
